import styled from 'styled-components';
import { TIDD } from '../index';
import { ControlsButton, List, ListInner, TableStyled, TitleWrapper } from 'app/Pages/common/List/styles';

// Height of the overlaid pagination bar (ListPagination: 20px*2 padding + 1px border + ~24px content).
const PAGINATION_HEIGHT = '65px';

export const ColStatus = styled.div<{ status?: TIDD['status'] }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
  background-color: ${({ theme, status }) =>
    status && theme.colors.idd_status[status] ?
      theme.colors.idd_status[status] :
      theme.colors.idd_status['unknown']};
`;

export const ColStatusData = styled.div`
  padding-top: 2px;
  display: flex;
  align-items: center;
`;

export const IDDListButton = styled(ControlsButton)`
  height: 38px;
`;

export const TableIDD = styled(TableStyled)<{ $hasPagination?: boolean }>`
  .qmt-ui-table__head {
    padding: 6px;
    ${IDDListButton} {
      align-self: center;
    }
  }
  // The scrollable body now reaches the viewport bottom, so the library's
  // dropdown open-direction check (measured against window height) stays
  // accurate. Reserve room for the overlaid pagination bar so the last rows
  // and their downward-opening status dropdown clear it.
  .qmt-ui-table__body {
    ${({ $hasPagination }) => $hasPagination && `
      padding-bottom: ${PAGINATION_HEIGHT};
    `}
  }
  // Lift an open status dropdown above the overlaid pagination bar.
  .qmt-ui-dropdown--opened {
    z-index: 2;
  }
`;

// position: relative anchors the absolutely positioned pagination overlay.
export const IDDListInner = styled(ListInner)`
  position: relative;
`;

// Pagination is lifted out of flow and overlaid at the bottom so the table
// body can fill down to the viewport edge (see TableIDD body comment).
export const IDDPaginationWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  z-index: 1;
`;

// On the customer profile tab the list has no room to spare: drop the top, right
// and left padding so the table (and its overlaid pagination) reach the edges.
export const IDDList = styled(List)<{ customerPage?: boolean }>`
  ${({ customerPage }) => customerPage && `
    padding-top: 0;
    padding-right: 0;
    padding-left: 0;
  `}
`;

export const IDDListTitleWrapper = styled(TitleWrapper)<{ customerPage?: boolean }>`
  padding-right: 6px;
  ${({ customerPage }) => customerPage ? `
    margin-top: 0;
    margin-bottom: 20px;
  ` : `
    margin-top: -7px;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const PolicyLink = styled.span<{ onClick?: () => void }>`
    ${({ onClick, theme }) => onClick && `
      color: ${theme.colors.primary};
      cursor: pointer;
    `}
`;

export const PolicyNumbersData = styled.div`
  max-height: 60px;
  overflow-y: auto;
  overflow-x: hidden;
  ${({ theme }) => theme.text.small};
  color: ${({ theme }) => theme.colors.textSecondary};
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.border} transparent;
`;
